import {
  changeProperty,
  changeTempUserProperty,
  CREATE_NEW_TEMP_USER,
  createNewRespondent,
  DATE_OF_VALIDITY,
  DEACTIVATE_TEMP_USER,
  deactivateTempUserAction,
  EDIT_TEMP_USER_DIALOG,
  EMAIL,
  FIRSTNAME,
  getTempUserLink,
  IDENTIFIER,
  LASTNAME,
  loadTempUser,
  loadTempUsers,
  SHOW_INACTIVE_RESPONDENTS,
  SHOW_TEMP_USER_DIALOG,
  SHOW_TEMP_USER_LINK,
  TEMP_USER_LINK,
  TEMP_USER_LIST,
  TEMPORARY_USER,
  TEMPORARY_USER_ID,
  TEMPORARY_USER_USERNAME,
  updateTempUser,
  USERNAME,
  USERNAME_ALREADY_EXISTS
} from "../../../ducks/manageSurveyTempUsers";

import { CURRENT_USERNAME_IS_VALID } from "../../../ducks/userManagement";
import ManageSurveyTempUser from "./ManageSurveyTempUser";
import { bindActionCreators } from "redux";
import { clearMessages } from "../../../ducks/message";
import { connect } from "react-redux";
import { loadRespondentList } from "../../../ducks/respondentsOverview";

const mapStateToProps = (state) => {
  return {
    showTempUserDialog: state.manageSurveyTempUsers[SHOW_TEMP_USER_DIALOG],
    tempUserList: state.manageSurveyTempUsers[TEMP_USER_LIST],
    showInactiveRespondents: state.manageSurveyTempUsers[SHOW_INACTIVE_RESPONDENTS],
    editTempUserDialog: state.manageSurveyTempUsers[EDIT_TEMP_USER_DIALOG],
    temporaryUser: state.manageSurveyTempUsers[TEMPORARY_USER],
    temporaryUserId: state.manageSurveyTempUsers[TEMPORARY_USER_ID],
    temporaryUserUsername: state.manageSurveyTempUsers[TEMPORARY_USER_USERNAME],
    firstname: state.manageSurveyTempUsers[FIRSTNAME],
    lastname: state.manageSurveyTempUsers[LASTNAME],
    email: state.manageSurveyTempUsers[EMAIL],
    dateOfValidity: state.manageSurveyTempUsers[DATE_OF_VALIDITY],
    createNewTempUser: state.manageSurveyTempUsers[CREATE_NEW_TEMP_USER],
    deactivateTempUser: state.manageSurveyTempUsers[DEACTIVATE_TEMP_USER],
    showTempUserLink: state.manageSurveyTempUsers[SHOW_TEMP_USER_LINK],
    tempUserLink: state.manageSurveyTempUsers[TEMP_USER_LINK],
    identifier: state.manageSurveyTempUsers[IDENTIFIER],
    username: state.manageSurveyTempUsers[USERNAME],
    usernameAlreadyExists: state.manageSurveyTempUsers[USERNAME_ALREADY_EXISTS],
    currentUsernameIsValid: state.manageSurveyTempUsers[CURRENT_USERNAME_IS_VALID]
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      changeProperty,
      loadTempUsers,
      deactivateTempUserAction,
      loadTempUser,
      changeTempUserProperty,
      updateTempUser,
      getTempUserLink,
      createNewRespondent,
      loadRespondentList,
      clearMessages
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageSurveyTempUser);
